import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=41353920&scoped=true&"
import script from "./ResetPasswordView.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordView.vue?vue&type=style&index=0&id=41353920&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41353920",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VForm,VImg,VLayout,VTextField})
